import BlueButton from 'components/inputs/BlueButton'
import React from 'react'
import { Modal } from 'react-bootstrap'

interface IAfterOrderRequestDialogProps {
  open: boolean
  onClose: VoidFunction
}

const AfterOrderRequestDialog: React.FC<IAfterOrderRequestDialogProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Ваш заказ обрабатывается</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Уважаемый клиент! Ваше обращение принято в работу.
        <br />С Вами свяжется менеджер в течение часа согласно графика:
        <br /> Пн-Пт с 09:00 до 19:00
        <br />
        <strong>ВАЖНО!</strong>
        <br /> Ваш заказ будет отменен через <strong>семь дней</strong>, если его не
        забрать.
      </Modal.Body>
      <Modal.Footer>
        <BlueButton onClick={onClose}>Понятно</BlueButton>
      </Modal.Footer>
    </Modal>
  )
}
export default AfterOrderRequestDialog
